// extracted by mini-css-extract-plugin
export var parcelRow = "_rh-0";